import { createSelector } from 'reselect';

const getIsLoading = (state) => state?.loading?.isLoading;

const getFinal = (state) => {
    return state.final;
};

const getGameTab = (state) => {
    const {
        views: {
            game_tab
        } = {}
    } = state;
    return game_tab;
};

const getConfigGameContext = (state) => state?.config?.context?.gameContext ?? state?.config?.failsafeGameContext;
const getConfigEnableTabsFinal = (state) => state?.config?.enableTabsFinal;

// reselect function
export const getFinalState = createSelector(
    [getFinal, getIsLoading, getGameTab, getConfigGameContext, getConfigEnableTabsFinal],
    (final, isLoading, game_tab, gameContext, enableTabsFinal) => {
        return {
            ...final,
            isLoading,
            game_tab,
            gameContext,
            enableTabsFinal
        };
    }
);
